// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"EventManagement_loadingContainer__2csl-"};